import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//-----框架配置
// 导入vant组件
import '@/utils/vant.js'
import  './utils/rem'
//------------
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

import * as echarts from 'echarts' //引入echarts
Vue.prototype.$echarts = echarts //引入组件


Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
